module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.fd9d30ed.woff2";